import React from 'react'
import styled from 'styled-components'
import {Icon} from './library/icon/icon'

export const WarningBanner = ({
  message,
  mode = 'warning'
}: {
  message: string
  mode?: 'warning' | 'error'
}) => (
  <WarningWrapper mode={mode}>
    <Icon name="info" />
    {message}
  </WarningWrapper>
)

const WarningWrapper = styled.div<{mode: 'warning' | 'error'}>`
  padding: 20px;
  display: flex;
  align-items: center;

  color: ${({theme, mode}) =>
    mode === 'warning' ? theme.colors.orange9 : theme.red};

  border: 1px solid
    ${({theme, mode}) =>
      mode === 'warning' ? theme.colors.orange9 : theme.red};
  border-radius: 5px;

  > svg {
    color: ${({theme, mode}) =>
      mode === 'warning' ? theme.colors.orange9 : theme.red};
    margin-right: 8px;
  }
`
